import atendimentoEmCasa from "../assets/images/noticias/v2/atendimento-em-casa.webp";
import fundefAcordo from "../assets/images/noticias/v2/fundef-acordo.webp";
import fundefFundeb from "../assets/images/noticias/v2/fundef-fundeb.webp";
import pgm46Anos from "../assets/images/noticias/v2/pgm-46-anos.webp";
import portalNovo from "../assets/images/noticias/v2/portal-novo.webp";
import refis2025 from "../assets/images/noticias/v2/refis-2025.webp";
import transacaoHotelaria from "../assets/images/noticias/v2/transacao-hotelaria.webp";
import valeriaLopes from "../assets/images/noticias/v2/valeria-lopes.webp";

export interface NewsItem {
  date: string;
  image: string;
  path: string;
  slug: string;
  title: string;
}

export const news: NewsItem[] = [
  {
    slug: "valeria-lopes",
    date: "07 de abril de 2026",
    title:
      "Subprocuradora-geral Valéria Lopes publica Artigo em Jornal sobre Inovação e Recuperação da Dívida Ativa Municipal",
    path: "/valeria_lopes_publica_artigo_em_jornal",
    image: valeriaLopes,
  },
  {
    slug: "fundef-acordo",
    date: "04 de fevereiro de 2026",
    title:
      "Atuação do Núcleo de Contencioso Estratégico da PGM garante acordo histórico do Fundef e beneficia professores e alunos de Fortaleza",
    path: "/fundef_agreement",
    image: fundefAcordo,
  },
  {
    slug: "refis-2025",
    date: "30 de setembro de 2025",
    title: "Refis 2025",
    path: "/refis_2025",
    image: refis2025,
  },
  {
    slug: "pgm-46-anos",
    date: "23 de maio de 2025",
    title: "Especial PGM 46 anos",
    path: "/pgm_birthday",
    image: pgm46Anos,
  },
  {
    slug: "fundef-fundeb",
    date: "19 de maio de 2025",
    title: "Esclarecimento sobre ações do FUNDEF e FUNDEB",
    path: "/fundef_fundeb",
    image: fundefFundeb,
  },
  {
    slug: "transacao-hotelaria",
    date: "24 de novembro de 2022",
    title: "Modalidade de Transação Tributária proposta para a Rede Hoteleira",
    path: "/transacao_tributaria",
    image: transacaoHotelaria,
  },
  {
    slug: "atendimento-em-casa",
    date: "28 de outubro de 2022",
    title: "Você pode ser atendido sem sair de casa",
    path: "/atendimento_sem_sair_de_casa",
    image: atendimentoEmCasa,
  },
  {
    slug: "portal-novo",
    date: "20 de agosto de 2021",
    title: "News! Portal PGM está de cara nova",
    path: "/noticia",
    image: portalNovo,
  },
];
